<template>
  <el-dialog
    title="打包下载"
    :visible.sync="visible"
    append-to-body
    @close="close()"
    width="30%">
     <el-form ref="ruleForm" class="orgForm">
        <el-table
          ref="multipleTable"
          :data="notaryFileList"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column
              type="selection"
              width="55"
              label="">
            </el-table-column>
            <el-table-column
              prop="name"
              width="120"
              label="材料列表">
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="创建时间"
              show-overflow-tooltip>
            </el-table-column>
        </el-table>

      <el-form-item>
        <el-button size="small" type="primary" @click="downToZIP()">确定打包</el-button>
        <el-button size="small"  @click="close()">取消</el-button>
      </el-form-item>
     </el-form>
    </el-dialog>
</template>

<script>
export default {
    data() {
        return {
            notaryFileList: [],//材料列表
            printer: '', //打印机
            notaryDocumentList: [], //证据材料列表
            notaryZhixing: [], //执行材料列表
            printerList: [], //打印机列表
            visible: false,
            multipleSelection: [],//选中的材料列表
            pathList:[],
            contractId: '',
            contractType: '', //用来判断是公证还是执行
        }
    }, 
    methods: {
        //点击保存按钮执行的事件
        handleSelectionChange(val) {
            this.multipleSelection =val; //获取选中的材料
            this.pathList = [];
            console.log("后续更改后选中的材料为:",this.multipleSelection)
            this.multipleSelection.forEach(item =>{
                this.pathList.push(item.path)
            });
        },
        open(notaryDocumentList,contractId,contractType){
            this.contractId = contractId;
            this.contractType = contractType;
            console.log("打印的卷宗是:",this.contractId)
            console.log("传入的值为:",this.contractType)
            this.visible = true;
            this.notaryFileList = notaryDocumentList;
            
            this.$nextTick(() => {
                this.notaryFileList.forEach(item =>{
                    this.multipleSelection.push(item);
                    this.$refs.multipleTable.toggleRowSelection(item,true);
                    
                })
                console.log("证据材料列表为:",this.notaryFileList);
                console.log("选中的材料列表为:",this.multipleSelection);
            })
            
        },
        close(){
            this.pathList = [];
            this.multipleSelection = [];
            this.visible = false;
        },
        //打印功能
        downToZIP(){
            if(this.pathList.length == 0){
                this.$alert('请选择材料！', '提示', {
                    confirmButtonText: '确定',
                });
            }else{
                this.$api.downloadToZIP({
                    contractId: this.contractId,
                    pathList: this.pathList,
                    contractType: this.contractType,
                }).then(res => {
                    if (res.data.code === '200') {
                        console.log('res',res)
                        let url = res.data.data.result.data.urf
                        let fileName = res.data.data.fileName
                        const a = document.createElement('a')
                        a.href = url
                        console.log('fileName是',fileName)
                        
                        a.download = fileName // 下载后文件名
                        // a.setAttribute('download',filename);
                        a.style.display = 'none'
                        document.body.appendChild(a)
                        a.click() // 点击下载
                        document.body.removeChild(a) // 下载完成移除元素

                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.data,
                        })
                    }
                })
            }
        },
    }
}
</script>
<style scoped>
.el-form-item {
  margin-bottom: 12px;
}
</style>